export const ELASTIC_SEARCH_MAXIMUM_PAGE = 5000
